import './styles.scss';

import logoutIcon from '../../assets/sair.png';

type ButtonProps = {
    onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

export function ButtonSignOut(props: ButtonProps) {
    return (
        <button name="submit" id="submit" className="button2" {...props}>
            <img src={logoutIcon} alt="sair" />
        </button>
    )
}
